import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        [
          _c(VDataTable, {
            key: _vm.keyTable,
            staticClass: "text-center table-inca",
            attrs: {
              responsive: "",
              hover: "",
              items: _vm.updateHours,
              headers: _vm.headers,
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenEditDialog(item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-edit")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Editar hora de actualización")])]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenDialog(
                                                _vm.DIALOG_DELETE_UPDATE_HOUR,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-delete")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Eliminar hora de actualización")])]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD_UPDATE_HOUR,
        attrs: { title: "Añadir hora de actualización" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(VTimePicker, {
                  attrs: { "full-width": "", flat: "" },
                  model: {
                    value: _vm.updateTime,
                    callback: function ($$v) {
                      _vm.updateTime = $$v
                    },
                    expression: "updateTime",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.onSubmitUpdateHour },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.add")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_EDIT_UPDATE_HOUR,
        attrs: { title: "Editar hora de actualización" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(VTimePicker, {
                  attrs: { "full-width": "", flat: "" },
                  model: {
                    value: _vm.updateTime,
                    callback: function ($$v) {
                      _vm.updateTime = $$v
                    },
                    expression: "updateTime",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.onSubmitUpdateHour },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.save")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE_UPDATE_HOUR,
        attrs: { title: "Confirmación" },
        on: { onConfirm: _vm.onConfirmDeleteUpdateHour },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }